exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tax-team-container[data-v-114873c0]{width:100%;text-align:left;border-bottom:1px solid #000;line-height:.1em;margin:40px 0 20px}.tax-team-container .tax-team-text[data-v-114873c0]{background:#fff;padding:0 10px 0 0}", ""]);

// exports
